import { Inclusion } from 'lib/types/trip';

const DESKTOP_INCLUSIONS_SUMMARY_LIMIT = 6;

export const filterInclusions = (
  inclusions: Inclusion[],
  userCountry: string | null
) => {
  return inclusions.filter((inclusion) => {
    if (!userCountry) {
      return true;
    }
    if (!inclusion.validCountries || !inclusion.validCountries.length) {
      return true;
    }
    return inclusion.validCountries.includes(userCountry);
  });
};

export const getDesktopInclusionsSummary = (
  inclusions: Inclusion[],
  userCountry: string | null
) => {
  const countryValidInclusions = filterInclusions(inclusions, userCountry);

  return {
    inclusions: countryValidInclusions.slice(
      0,
      DESKTOP_INCLUSIONS_SUMMARY_LIMIT
    ),
    remainingCount: Math.max(
      countryValidInclusions.length - DESKTOP_INCLUSIONS_SUMMARY_LIMIT,
      0
    ),
  };
};
